module.exports = __webpack_public_path__ + "img/socialimage.6505080b.svg";